import React from 'react';
import { parseNewLines } from '@alfa-bank/site-helpers-common/react/parse-new-lines';
import cn from 'classnames';

import type { TDesktop } from '../../models/desktop';
import type { TMobile } from '../../models/mobile';

/**
 * Функция отображения подзаголовка в основной версии баннера
 */
export function bannerSubtitle(props: TDesktop | TMobile) {
    const { Text, styles, subtitle, theme } = props;

    return subtitle ? (
        <Text
            className={cn(styles.subtitle, styles.external)}
            kind="subtitle"
            marginBottom={false}
            marginTop={false}
            theme={theme}
        >
            {parseNewLines(subtitle)}
        </Text>
    ) : null;
}
